angular.module('app.filters').filter('count', () => (items) => {
    if (null === items || !items) {
        return 0;
    } else if ('object' === typeof items) {
        return Object.keys(items).length;
    } else if ('undefined' !== typeof items) {
        return items.length || 0;
    }

    return 0;
});
